/** @jsxRuntime classic */
/** @jsxFrag React.Fragment */
/** @jsx jsx */
import { LoadingAnimation, Modal, colors } from '@bonitour/components'
import { css, jsx } from '@emotion/core'
import { useReservation } from 'hooks/context/Reservation'
import { useMemo, useEffect } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { useTicketsCheckin } from './hooks/useTicketsCheckIn'
import { loadingContainer } from 'assets/styles/global'
import { TicketCheckinList } from './TicketList'
import { SelectedTicketsDialog } from 'domains/MyDay/SelectedTicketsDialog/SelectedTicketsDialog'

const reservationLink = css`
  font-size: 1.25rem;
  display: block;
  margin-top: -1.125rem;
  margin-bottom: 1.5rem;
  color: ${colors.primary};
  text-decoration: none;
  font-weight: 500;
`

export const ReservationTicketListModal = ({ reservationId, onClose }) => {
  const { reservationCode, reservationTickets, fetchReservationTickets, reservationTicketLoading } = useReservation()

  useEffect(() => {
    if (reservationId) {
      fetchReservationTickets()
    }
  }, [reservationId, fetchReservationTickets])

  const reservationTicketCodes = useMemo(
    () => reservationTickets
      ?.flatMap(([_date, services]) => services)
      ?.flatMap(({ tickets }) => tickets)
      ?.map(({ ticketCode }) => ticketCode)
      ?.join(';'),
    [reservationTickets]
  )

  const { isModalVisible, validateCode, onModalClose, ticketList, onValidateClick, loading, selectedCode } = useTicketsCheckin({ code: reservationTicketCodes })

  const selectedTickets = useMemo(
    () => ticketList.filter(ticket => ticket.code === selectedCode),
    [ticketList, selectedCode]
  )

  return (
    <Modal
      title='Ingressos da Reserva'
      onCloseClick={onClose}
      isVisible={Boolean(reservationId)}
    >
      {(reservationTicketLoading || loading)
        ? <LoadingAnimation css={loadingContainer} />
        : (
          <>
            {reservationCode && reservationId && (
              <Link to={`/reservation/${reservationId}`} target='_blank' rel='noopener noreferrer' css={reservationLink}>
                {reservationCode}
              </Link>
            )}
            <TicketCheckinList ticketList={ticketList} onValidate={onValidateClick} loading={loading} insideModal />
          </>
        )
      }
      <SelectedTicketsDialog
        isVisible={isModalVisible}
        quantity={1}
        onCloseDialog={onModalClose}
        onSubmitValidation={validateCode}
        ticketsDetails={selectedTickets}
      />
    </Modal>
  )
}
